<template>
  <div>
    <!-- Popup para cuando no se quiera mostrar el Catálogo -->
    <div
      class="modal fade"
      id="modalPopup"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div style="margin:auto">
          <div id="boton" class="boton">
            <button
              type="button"
              class="close close-info-l"
              data-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div class="row justify-content-center">
            <img alt="popup" width="100%" :src="this.imgSinCatalogue">
          </div>
        </div>
      </div>
    </div>
    <nav :class="classNavbar" id="navbar-landing">
      <div class="container-img">
        <img style="cursor: pointer" @click="irInicio()" width="124" height="40" src="./../assets/icon/hav_logo.svg"
          class="img-navbar" title="logo havoline moto club" alt="logo havoline moto club"/>
      </div>
      <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav mr-auto">
        </ul>
        <div class="form-inline my-2 my-lg-0 ">
          <ul class="navbar-nav mx-auto">

            <div v-for="item in itemMenu" :key="item.id">
              <!-- {{ item.subItem.length }} -->
              <router-link v-if="item.subItem.length == 0" :key="item.id" :to="{ name: item.routeName }" :class="{
                      active: $route.name === item.routeName,
                      'nav-item': true,
                      'nav-link': true
                    }">
                <span @click="ocultar">{{ item.text }}</span>
              </router-link>
              <li v-else class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  {{item.text}}
                </a>
                <div style="margin-bottom:20px;" class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <router-link v-for="data in item.subItem " :key="data.id" class="dropdown-item text-danger"
                    :to="{ name: data.routeName }" :class="{
                      active: $route.name === data.routeName,
                      'nav-item': true,
                      'nav-link': true
                    }">
                    <span @click="ocultar">{{ data.text }}</span>
                  </router-link>
                </div>
              </li>
            </div>

            <!-- Categorías de alianzas -->
            <template v-if="categories.length > 0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  Alianzas
                </a>
                <div style="margin-bottom:20px;" class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <router-link v-for="data in categories" :key="data.id" class="dropdown-item text-danger"
                    :to="{ name: 'alliances', params: { name: data.name } }" :class="{
                      active: $route.name === data.name,
                      'nav-item': true,
                      'nav-link': true
                    }">
                    <span @click="ocultar">{{ data.name }}</span>
                  </router-link>
                </div>
              </li>
            </template>

            <div v-for="item in itemMenu2" :key="item.id">
              <!-- {{ item.subItem.length }} -->
              <router-link v-if="item.subItem.length == 0" :key="item.id" :to="{ name: item.routeName }" :class="{
                      active: $route.name === item.routeName,
                      'nav-item': true,
                      'nav-link': true
                    }">
                <span @click="ocultar">{{ item.text }}</span>
              </router-link>
              <li v-else class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false">
                  {{item.text}}
                </a>
                <div style="margin-bottom:20px; min-width:180px;" class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <router-link to="/catalogo" :class="{
                            active: $route.name === 'catalogue',
                            'nav-item': true,
                            'nav-link': true,
                          }">
                    <span style="color:#dc3545; padding:10px" @click.prevent="Catalogue()">Catálogo Motero</span>
                  </router-link>
                  <router-link to="/catalogo/lub" :class="{
                            active: $route.name === 'catalogoLub',
                            'nav-item': true,
                            'nav-link': true,
                          }">
                    <span style="color:#dc3545; padding:10px" @click.prevent="CatalogueLub()">Catálogo Lubricador</span>
                  </router-link>
                </div>
              </li>
            </div>
            <router-link v-if="campaingName != ''" to="/campaing" :class="{
                      active: $route.name === 'campaing',
                      'nav-item': true,
                      'nav-link': true,
                      'mx-2': true
                    }">
              <span @click.prevent="ocultar">{{ campaingName }}</span>
            </router-link>
            <li class="mx-1 nav-item dropdown rounded bg-danger my-2 my-lg-0 ">
              <a class="nav-link dropdown-toggle text-white font-weight-normal" href="#" id="navbarDropdown1" role="button" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                Iniciar sesión
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown1">
                <ul>
                  <li @click="ocultar" class="dropdown-item text-danger">
                    <router-link class="nav-item nav-link" to="/login/lubricador">Soy mecánico</router-link>
                  </li>
                  <li @click="ocultar" class="dropdown-item text-danger">
                    <router-link class="nav-item nav-link" to="/login">Soy motero</router-link>
                  </li>
                  <li @click="ocultar" class="dropdown-item text-danger">
                    <router-link class="nav-item nav-link" to="/login-distribuidor">Soy distribuidor</router-link>
                  </li>
                  <li @click="ocultar" class="dropdown-item text-danger">
                    <router-link class="nav-item nav-link" to="/login-punto-de-venta">Soy punto de venta</router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li class="mx-1 nav-item dropdown rounded bg-danger my-2 my-lg-0 ">
              <a class="nav-link dropdown-toggle text-white font-weight-normal" href="#" id="navbarDropdown2" role="button" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                Regístrate
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown2">
                <ul>
                  <li @click="ocultar" class="dropdown-item text-danger">
                    <button class="nav-item nav-link"  data-toggle="modal" data-target="#show_message_register">Soy mecánico</button>
                  </li>
                  <!-- <li @click="ocultar" class="dropdown-item text-danger">
                    <router-link class="nav-item nav-link" to="/register">Soy motero</router-link>
                  </li> -->
                </ul>
              </div>
            </li>
            <!-- <button class="btn btn-sm btn-sm-nav btn-danger icon-network1-instagram mt-c" @click=" irLubricator()">
              Soy mecánico
            </button>
            <button class="btn btn-sm btn-sm-nav btn-danger icon-network1-instagram mt-c" @click=" irLogin()">
              Iniciar sesión
            </button>
            <button class="btn btn-sm btn-sm-nav btn-danger icon-network1-instagram mt-c"
              @click=" irRegistro()">Registro
            </button> -->
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  import $ from 'jquery';
  import axios from 'axios';

  export default {
    name: "navbar",
    data() {
      return {
        classNavbar: "navbar fixed-top navbar-expand-lg navbar-light bg-light",
        campaingName: "",
        alliance: [],
        itemMenu: [
          {
            id: 1,
            routeName: "landingPage",
            text: "Inicio",
            count: true,
            subItem: []
          },
          {
            id: 2,
            routeName: "listAllHavoblogs",
            text: "Havoblog",
            count: true,
            subItem: []
          },
          {
            id: 3,
            routeName: "GetToKnowTheClub",
            text: "Conoce el club",
            count: true,
            subItem: []
          },
          // {
          //   id: 4,
          //   routeName: "club",
          //   text: "¿Qué es el club?",
          //   count: true,
          //   subItem: []
          // },
          // {
          //   id: 5,
          //   routeName: "registerCodes",
          //   text: "¿Cómo registrar códigos?",
          //   count: true,
          //   subItem: []
          // },
          // {
          //   id: 6,
          //   routeName: "contact",
          //   text: "Contáctanos",
          //   count: true,
          //   subItem: []
          // },
          // {
          //   id: 7,
          //   routeName: "frequentQuestions",
          //   text: "Preguntas frecuentes",
          //   count: true,
          //   subItem: []
          // }
        ],
        itemMenu2: [
          {
            id: 1,
            routeName: "catalogue",
            text: "Catálogo",
            count: true,
            subItem: [
              {
                id: 2,
                routeName: "catalogue",
                text: "Catálogo Motero",
              },
              {
                id: 3,
                routeName: "catalogueLub",
                text: "Catálogo Lubricador",
              },
            ],
          },
          {
            id: 4,
            routeName: "sectionWebProduct",
            text: "Productos",
            count: true,
            subItem: []
          },
        ],
        session: sessionStorage.getItem('token'),
        popups: [],
        imgSinCatalogue: null,
        flagCatalogue: false,
        arrayCategories: [],
        categories: {},
      };
    },
    watch: {
      session: function (newSession) {
        // console.log(newSession);
      }
    },
    methods: {
      Catalogue(){
        this.ocultar();
        if(this.flagCatalogue == true){
          $('#modalPopup').modal('show');
        } else {
          this.$router.push({name: "catalogue"});
        }
        this.ocultar();
      },
      CatalogueLub(){
        this.ocultar();
        if(this.flagCatalogue == true){
          $('#modalPopup').modal('show');
        } else {
          this.$router.push({name: "catalogueLub"});
        }
        this.ocultar();
      },
      ocultar(){
        var navMain = $("#navbarCollapse");
        navMain.collapse('hide');
      },
      irInicio() {
        this.$router.push({name: "landingPage"});
        var navMain = $("#navbarCollapse");
        navMain.collapse('hide');
      },
      irLogin() {
        this.$router.push({name: "login"});
        var navMain = $("#navbarCollapse");
        navMain.collapse('hide');
      },
      irLubricator() {
        this.$router.push({name: "loginLubricator"});
        var navMain = $("#navbarCollapse");
        navMain.collapse('hide');
      },
      irDistributor() {
        this.$router.push({name: "loginDistributor"});
        var navMain = $("#navbarCollapse");
        navMain.collapse('hide');
      },
      irRegistro() {
        this.$router.push({name: "registerUser"});
        var navMain = $("#navbarCollapse");
        navMain.collapse('hide');
      },
      irCode() {
        let sesion = sessionStorage.getItem('token');
        if (sesion == '' || sesion == null) {
          this.$router.push({name: "login"});
        } else {
          this.$router.push({name: "homeUser"});
        }
        var navMain = $("#navbarCollapse");
        navMain.collapse('hide');
      },
      showModalRegister(){
        $('.modal-backdrop').remove();
      },
      getCampaingName() {
        axios
          .get("api/file/get/banners/1")
          .then(res => {
            // console.log(res.data.data[0].files[0].description);
            this.campaingName = res.data.data[0].files[0].description;
          })
          .catch(error => {
            console.log(error);
          });
      },
      getAlliances(){
        axios
          .get("api/file/get/alliancesActive")
          .then(res => {
            this.alliances = res.data.data;
            for(var i = 0; i < this.alliances.length; i++){
              if(this.alliances[i].status_id == 1){
                this.alliance.push(this.alliances[i]);
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      getBanners(){
        axios
          .get("api/files/histories/6")
          .then(res => {
            if (res.data.cod == 0) {
              this.popups = res.data.data;
              this.popups.forEach(popup => {
                if(popup.location == 2 && popup.status_id == 1){
                  this.imgSinCatalogue = popup.url;
                  this.flagCatalogue = true;
                  this.blockCatalogo();
                  // console.log('this.imgSinCatalogue ', JSON.stringify(this.imgSinCatalogue));
                }
              });
            }
          })
          .catch(error => {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
          });
      },
      getCategories(){
        let app = this;
        axios
        .get("api/get/categories")
        .then(res => {
          app.arrayCategories = res.data.data;
          app.categories = app.arrayCategories.filter(element => element.status_id == 1);
        })
        .catch(error => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      },
      blockCatalogo(){
        var urlActual = window.location.href;
        var url = urlActual.split('/');
        if(url[3] == 'catalogo' && this.flagCatalogue == true){
          this.$router.push({ name: "landingPage" });
          $('#modalPopup').modal('show');
        }
      },
    },
    mounted() {
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();
      this.getCampaingName();
      this.getAlliances();
      this.getBanners();
      this.getCategories();
    }
  };
</script>

<style scope>
  .dropdown-item.active {
    background-color: #007bff00;
    color: #1da5df !important;
  }
  .icon-style {
    font-size: 25px;
    color: #dc3545;
    padding: 6px;
  }
  .navbarProfile {
    background-color: #000000b8 !important;
  }
  .container-img {
    margin: 0%;
  }
  .navbar {
    background-color: #fff !important;
    /* padding: 0rem 0rem !important; */
  }
  .btn-sm-nav {
    height: 31px !important;
  }
  .navbar-light .navbar-nav .nav-link {
    font-size: 15px !important;
    color: #dc3545;
    font-weight: bold;
    padding: 5px !important;
  }

  /* Cuando está active */
  .navbar-light .navbar-nav .nav-link.active,
  .navbar-light .navbar-nav .nav-link.show,
  .navbar-light .navbar-nav .show>.nav-link {
    color: #1DA5DF;
  }
  .icon-network1-instagram {
    margin-top: 5px;
    margin-left: 0px;
  }

  .close-navbar {
    display: none;
  }


@font-face {
  font-family: "ArialNarrow";
  src: url("./../assets/font/ArialNarrow.ttf");
  font-display: swap;
}

    
    .navbar {
      background-color: white !important;
      padding: 0.5rem 1rem !important;
    }
    .icon-network1-instagram {
      margin-top: 5px;
      margin-left: 0px;
    }
    .close-navbar {
      display: none;
    }
  

  @font-face {
    font-family: "ArialNarrow";
    src: url("./../assets/font/ArialNarrow.ttf");
    font-display: swap;
  }

  #modalPopup{
    position: fixed;
    z-index: 10000;
    /* max-width: 80%;
    max-height: 80%; */
    margin: auto !important;
  }
  ::-webkit-scrollbar {
    display: none;
  }
  #boton{
    margin: -25px 0px 0px 0px;
  }

  #navbar_catalogue{
    min-width: 180px;
  }
</style>